import React from "react";
import PropTypes from "prop-types";
import WidgetOptions from "../WidgetOptions";
import classnames from "classnames";
import Iframe from "react-iframe";

const IFrameWidget = ({
    configs: {
        widgetDisplayName = "",
        widgetUrl = ""
    },
    isEditMode = false,
    isDashboardFullScreen = false,
    onForceUpdateClick = () => { },
    onEditClick = () => { },
    onDuplicateClicked = () => { },
    onDeleteClicked = () => { }
}) => {
    return (
        <div className="iframe-container widget">
            <div className="ibox-title widget-top-corners widget-display-name">
                <h5 style={{marginBottom: "0"}}>{widgetDisplayName}</h5>
                <WidgetOptions
                    isEditMode={isEditMode}
                    className="widget-options widget-options-effect"
                    isDashboardFullScreen={isDashboardFullScreen}
                    onEditClicked={onEditClick}
                    onRefreshClicked={onForceUpdateClick}
                    onDuplicateClicked={onDuplicateClicked}
                    onDeleteClicked={onDeleteClicked}
                />
            </div>
            <div className={classnames("ibox-content-widget-area", "ibox-content-widget", "ibox-content-no-border")}>
                <Iframe
                    url={widgetUrl}
                    width="100%"
                    height="100%"
                    display="initial"
                    position="relative"
                    frameBorder={0}
                />
            </div>
        </div>
    );
};

IFrameWidget.propTypes = {
    widgetDisplayName: PropTypes.string,
    widgetUrl: PropTypes.string,
    isEditMode: PropTypes.bool,
    isDashboardFullScreen: PropTypes.bool,
    onRefreshClicked: PropTypes.func,
    onForceUpdateClick: PropTypes.func,
    onEditClick: PropTypes.func,
    onDuplicateClicked: PropTypes.func
};

export default IFrameWidget;
